import TillBasedSource from "./From/TillBasedSource";
import RoleBasedTarget from "./To/RoleBasedTarget";
import Shipping from "./Shipping";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import NewDefault from "./Buttons/NewDefault";
import PoolList from "./Picking/PoolList";
import List from "./List";

export default (componentProps) => {
    const {props, state, parent} = componentProps;
    const {hidden, labels, actionButtons} = props;
    const Editor = props.editor || BoxEditor;
    // {...{...componentProps, props: {...componentProps.props, getProps: (name) => {return {...componentProps.props.getProps(name),fields: ["provider"]}}}}}
    return <Fragment>
        <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
        <Editor
            theme="default"
            footer={<Fragment>
                {Array.isArray(actionButtons) ? actionButtons.map((i) => i) : actionButtons}
                <NewDefault {...componentProps} />
            </Fragment>}
        >
            {
                props.values.id && <form onSubmit={props.handleSubmit}>
                    <div className="row form-row">
                        <div className="col-md-6">
                            <TillBasedSource {...componentProps} />
                        </div>
                        <div className="col-md-6">
                            <RoleBasedTarget {...componentProps} />
                        </div>
                    </div>
                    <div className="row form-row">
                        <Shipping {...componentProps} />
                        {/*<Notenum {...componentProps} />*/}
                    </div>
                    <Comment {...componentProps} />
                    {props.values.target && <PoolList {...componentProps} control={{visible: false}}/>}
                </form>
            }
        </Editor>
    </Fragment>;
}